import React, {Component} from  'react';
import {connect} from 'react-redux';
// utils
import {formApiUrl,Translations} from '../../../../utils/';
// constant
import {FORM_REFS} from '../../../../constants';
// restClient
import {aemHostClient, eapiClient} from '../../../../restClient';
//action Creator
import {setOtherAccountAch} from '../../actions/actionCreator';
// children
import Dynamicform from '../../../common/Dynamicform/dynamicForm';
import {blockUi, unBlockUi} from '../../../../actions/actionCreator';

//style
import './styles.css';

class CreateAchOtherAccount extends Component {
  constructor(props) {
    super(props)
    this.state={}
  }

  componentWillMount() {
    this.props.blockUi();
    let apiURL = "/aemData/formData/json_create-other-ach-credit-account";
    if(this.props.mode === "edit"){
      apiURL = apiURL.replace("create-", "edit-");
    }

    aemHostClient(apiURL)
    .then(({data}) => {
      document.title =`${Translations(data.par.page_title_mainTitle.pageHeading,this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`;
      this.setState({formJson: data});
      this.props.unBlockUi();
    });
  }

  getFormData = (formData) => {
    this.setState({formData});
  }

  onFormSubmit = (event, apiURL) => {
    this.props.blockUi();
    var requestData = {
      ...this.state.formData,
      caseId: this.props.currentProductAch.caseId,
      bankName:'HSBC',
      hsbcAccount: 'hsbc'
    };
    // if(this.props.mode === 'edit') {
    //   apiURL = apiURL + "/" + this.state.formData.id;
    // }
    var METHOD = this.props.mode === 'edit' ? 'PUT' : 'POST';
    eapiClient(formApiUrl(apiURL, ":achId", this.props.currentProductAch.id), {
      method: METHOD,
      data: JSON.stringify(requestData)
    })
    .then(({data, status}) => {
      if(status === 201 || status === 200) {

        var key = window.sessionStorage.getItem("getCurrentDropDown");
        this.props.setOtherAccountAch(data.responseData.otherAccounts);
        window.sessionStorage.setItem('key'+ key, data.responseData.otherAccounts[data.responseData.otherAccounts.length-1].id);
        this.props.history.goBack();
        this.props.unBlockUi();
      }
    });
  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  renderFormGroups(){
    let formData;
    const savedPageStateString = window.sessionStorage.getItem("previousPageState");
    const savedPageState = savedPageStateString ? JSON.parse(savedPageStateString) :''
    var _currency = savedPageState.checkboxTaxonomy.others.filter(item =>{
      if(item.lid === savedPageState.formData.country.value){
        return item;
      }
    })
    if(this.props.currentOtherAccount !== undefined) {
      formData = {...this.props.currentOtherAccount};
    }else {
      formData = {
        country:{
          name:savedPageState.formData.country.name,
          value:savedPageState.formData.country.value
        },
        accountHolder:{
          name: this.props.currentProductAch.achAgent.name,
          value: this.props.currentProductAch.achAgent.value
        },
        currency:{
          name: _currency[0].name,
          value:_currency[0].id
        }
      };
    }
    const properties = {
      otherAccountId: this.props.match.params.otherAccountId,
      formData,
      editType: 'create-ach-other-account',
      pathname: this.props.history.location.pathname,
      setCountry : savedPageState.formData.country.value,
      currentCaseId: this.props.currentProductAch.caseId,
      actualMode : this.props.mode
    };
    if(this.state.formJson !== undefined && this.state.formJson.par.aemform_ !== undefined){
      return (
        <Dynamicform mode='edit'
        properties={properties}
        url={FORM_REFS[this.state.formJson.par.aemform_.formRef]}
        getFormData={this.getFormData}
        history={this.props.history}
        match={this.props.match}
        onFormSubmit={this.onFormSubmit}
        onFormCancel={this.onFormCancel}
        lang = {this.props.lang.currentLang.lang}
        translatedData ={this.props.lang.translatedData}
        flag={this.props.lang.currentLangFlag.flag}
        />
      );
    }
  }

  render(){
    const pageTitle = this.state.formJson ? this.state.formJson['par'].page_title_mainTitle : '';
    return(
      <div className="form-container">
      <div className="form-title">
      <h2 className="form-heading">
        {Translations(pageTitle.pageHeading,this.props.lang.currentLang.lang, this.props.lang.translatedData)}
      </h2>
      <p className="form-required-desc">
        {Translations(pageTitle.descriptionText,this.props.lang.currentLang.lang, this.props.lang.translatedData)}
      </p>
      </div>
      {this.renderFormGroups()}
      </div>
    );
  }
}

const mapDispatchToProps  = dispatch =>{
  return{
    setOtherAccountAch : accounts =>{
      dispatch(setOtherAccountAch(accounts))
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    }
  }
}

const mapStateToProps = (state, props) => {
  let currentOtherAccount = undefined;
  if(props.match.params) {
    var {otherAccountId} = props.match.params;
    if(otherAccountId && state.currentProductAch.data.formData.availableAccounts.length > 0) {
      state.currentProductAch.data.formData.availableAccounts.forEach(otherAccount => {
        if(otherAccount.id === otherAccountId) {
          currentOtherAccount = otherAccount;
        }
      });
    }
  }
  return {
    currentProductAch: state.currentProductAch.data.formData,
    currentOtherAccount,
    mode: currentOtherAccount !== undefined ? 'edit' : '',
    lang: state.lang
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateAchOtherAccount);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductAchCredit/createAchOtherAccount.js